import React from 'react'
import { Nav, NavLink, NavbarContainer, NavLogo, NavItems, GitHubButton, ButtonContainer, MobileIcon, MobileMenu, MobileLink, MobileOverlay } from './NavbarStyledComponent'
import { Bio } from '../../data/constants';
import { FaBars, FaTimes } from 'react-icons/fa';
import { useTheme } from 'styled-components';

const Navbar = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const theme = useTheme();

  const handleLogoClick = (e) => {
    e.preventDefault();
    const heroSection = document.getElementById('about');
    if (heroSection) {
      heroSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
    {isOpen && <MobileOverlay onClick={() => setIsOpen(false)} />}
    <Nav>
      <NavbarContainer>
        <NavLogo to='/' onClick={handleLogoClick}>
          <span style={{ color: theme.primary, fontWeight: 800, fontSize: 22, lineHeight: '1' }}>{'<'}</span>
          <span style={{ color: '#fff', fontWeight: 700, fontSize: 17, lineHeight: '1', fontFamily: 'Poppins, sans-serif', letterSpacing: '-0.3px' }}>Harsh</span>
          <span style={{ color: theme.primary, fontWeight: 800, fontSize: 22, margin: '0 1px', lineHeight: '1' }}>/</span>
          <span style={{ color: '#fff', fontWeight: 700, fontSize: 17, lineHeight: '1', fontFamily: 'Poppins, sans-serif', letterSpacing: '-0.3px' }}>Avichal</span>
          <span style={{ color: theme.primary, fontWeight: 800, fontSize: 22, lineHeight: '1' }}>{'>'}</span>
        </NavLogo>

        <NavItems>
          <NavLink href="#about">About</NavLink>
          <NavLink href='#skills'>Skills</NavLink>
          <NavLink href='#experience'>Experience</NavLink>
          <NavLink href='#projects'>Projects</NavLink>
          <NavLink href='#education'>Education</NavLink>
        </NavItems>

        <ButtonContainer>
          <GitHubButton href={Bio.github} target="_blank" rel="noopener noreferrer">Github Profile</GitHubButton>
        </ButtonContainer>

        <MobileIcon>
          {isOpen ? (
            <FaTimes onClick={() => setIsOpen(false)} />
          ) : (
            <FaBars onClick={() => setIsOpen(true)} />
          )}
        </MobileIcon>
        
        {isOpen && (
          <MobileMenu>
            <MobileLink href="#about" onClick={() => setIsOpen(false)}>About</MobileLink>
            <MobileLink href='#skills' onClick={() => setIsOpen(false)}>Skills</MobileLink>
            <MobileLink href='#experience' onClick={() => setIsOpen(false)}>Experience</MobileLink>
            <MobileLink href='#projects' onClick={() => setIsOpen(false)}>Projects</MobileLink>
            <MobileLink href='#education' onClick={() => setIsOpen(false)}>Education</MobileLink>
            <GitHubButton href={Bio.github} target="_blank" rel="noopener noreferrer" style={{ marginTop: 8, width: '100%', justifyContent: 'center' }}>
              Github Profile
            </GitHubButton>
          </MobileMenu>
        )}
      </NavbarContainer>
    </Nav>
    </>
  )
}

export default Navbar
